import { ReactComponent as InformationSvg } from '../../assets/images/icons/information.svg';
import { ReactComponent as WarningSvg } from '../../assets/images/icons/warning.svg';

export type IconName = 'information' | 'warning';

const icons: Record<IconName, React.FunctionComponent<React.SVGProps<SVGSVGElement>>> = {
  information: InformationSvg,
  warning: WarningSvg,
};

type IconProps = {
  name: IconName;
  size?: number;
  color?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
};

const Icon = ({ name, size = 24, color = '#ffeb3b', onClick }: IconProps) => {
  const Svg = icons[name];

  return (
    <Svg
      width={size}
      height={size}
      fill={color}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      aria-hidden
    />
  );
};

export default Icon;
